import { render } from "./PaginationCartTwo.vue?vue&type=template&id=3794b901"
import script from "./PaginationCartTwo.vue?vue&type=script&lang=js"
export * from "./PaginationCartTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__